<template>
  <label class="input-inside-chat-label">
    <span>{{ text }}</span>
    <select
      :value="value"
      class="input-inside-chat"
      :class="{ error: validate.$invalid && validate.$dirty }"
      @change="changeInput"
    >
      <!-- fix for Safari -->
      <option value disabled style="display: none"></option>
      <option v-for="option in options" :key="option.name" :value="option.name">
        {{ option.text }}
      </option>
    </select>
  </label>
</template>

<script>
export default {
  name: 'ChatSelect',
  props: {
    text: {
      type: String,
      default: null
    },
    value: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default() {
        return []
      }
    },
    validate: {
      type: Object,
      default() {
        return {}
      }
    }
  },

  methods: {
    changeInput($event) {
      this.$emit('input', $event.target.value)
      this.validate.$touch()
    }
  }
}
</script>
